import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Hero from "../../components/Hero";

function MainPage() {
  return (
    <div className="bg-white-blue main-bg">
      <Header />
      <Hero />
      <Footer />
    </div>
  );
}

export default MainPage;
